export const errors = {
  SESSION_TIMEOUT: 'Session timed out, please login.',
  ACCESS_DENIED: "Access denied! You don't have permission for this action!",
  ABORT_REQUEST: 'The user aborted a request',
  NETWORK_ERROR: 'NetworkError when attempting to fetch resource.',
  FAILED_TO_FETCH: 'Failed to fetch',
};

/**
 * Clean value, removing all non-numeric characters
 *
 * @param {string} value - Original value.
 * @returns {string} - Cleaned value.
 */
export const removeNonNumericCharacters = (value: string) => value.replace(/[^\d]/g, '');

/**
 * User's name initials
 *
 * @param {unknown} name - User object.
 * @returns {string} - Initial letter from user's firstname and lastname.
 */
export const splitUserName = (name?: string) => {
  if (!name) return '';

  const split = name
    ?.trim()
    ?.split(' ')
    ?.filter((str) => str !== '');
  if (split?.every((char) => char === 'undefined')) {
    return null;
  }

  if (split.length > 1) {
    return `${split[0][0]}${split[1][0]}`;
  } else {
    return `${split[0][0]}`;
  }
};
